import React from 'react';
import { useTranslation } from 'react-i18next';
import './NewGuideStyled.scss';
import UnderConstruction from '../../component/ui/Common/UnderConstruction';

const GwDBHGuide = () => {
  const { t } = useTranslation();

  return (
    <div className="new-guide-page">
      <div className="page-title p-16">GWDBH</div>
      
      {/* 실제 페이지 콘텐츠 - 배경으로 보임 */}
      <div className="new-guide-content">
        <h2>GWDBH</h2>
        <p>{t('guide.dbh.desc')}</p>
        
        {/* 더미 콘텐츠 */}
        <div className="new-stats-container">
          <div className="new-stat-card">
            <h3>{t('guide.dbh.cardMariaDB')}</h3>
            <div className="new-stat-value">- / -</div>
          </div>
          <div className="new-stat-card">
            <h3>{t('guide.dbh.cardMySQL')}</h3>
            <div className="new-stat-value">- / -</div>
          </div>
          <div className="new-stat-card">
            <h3>{t('guide.dbh.cardPostgreSQL')}</h3>
            <div className="new-stat-value">- / -</div>
          </div>
        </div>
      </div>
      
      {/* 공사중 표시 오버레이 */}
      <UnderConstruction />
    </div>
  );
};

export default GwDBHGuide;
